// extracted by mini-css-extract-plugin
module.exports = {"pessimization":"_93444fe79c--pessimization--3ALnW","strong":"_93444fe79c--strong--2bppg"};